import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { ClientAddFormLazy as ClientAddFormComponent } from '../../components/client_add_form/client_add_form_async';
import { BreadCrumbs } from '../bread_crumbs/bread_crumbs';
import { ICategory } from '../../types/client_add_form';
import { useAddBlogPage } from './useAddBlogPage';
import s from './add_blog.css';

const CATEGORIES: ICategory[] = [
  { id: '', value: '', label: 'Не выбрана' },
  { id: 'specialist', value: 'specialist', label: 'Специалист-специалисту' },
  { id: 'market_trend', value: 'market_trend', label: 'Тенденции рынка' },
];

export const AddBlog: React.FC = () => {
  const deviceType = useDeviceType();
  const { user, regions, tags, addBlog, editingItem, onSubmitAdd, onSubmitEdit, onUploadImage } = useAddBlogPage();

  return (
    <div className={s['add-blog__wrapper']}>
      <div className={s['breadcrumbs-wrap']}>
        <BreadCrumbs />
      </div>
      <ClientAddFormComponent
        user={user}
        item={addBlog.item}
        heading={addBlog.isEdit ? 'изменить запись в блоге' : 'новая запись в блоге'}
        titleFieldLabel="Заголовок"
        bodyEditorLabel="Текст"
        showLawBlock={true}
        showDescribeBlock={true}
        tags={tags.items.map(tag => tag.attributes.name)}
        showSubscribe={true}
        onSubmitAddForm={onSubmitAdd}
        regions={regions.items}
        error={addBlog.error}
        fetching={addBlog.fetching}
        categories={CATEGORIES}
        editingItem={editingItem}
        isEdit={addBlog.isEdit}
        onSubmitEditForm={onSubmitEdit}
        type="blog"
        deviceType={deviceType}
        uploadImage={onUploadImage}
      />
      <div className={s['breadcrumbs-wrap-mobile']}>
        <BreadCrumbs mobile={true} />
      </div>
    </div>
  );
};
